import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const imageUrl = (path) =>
  path && path.startsWith("/api") ? `${BACKEND_URL}${path}` : path;

export const api = axios.create({ baseURL: API });
